{
  "admin.loading": "Loading...",
  "admin.signedInAs": "Signed in as",
  "admin.signOut": "Sign out",
  "admin.menu.profile": "Profile",
  "admin.menu.administration": "Administration",
  "admin.menu.preferences": "Preferences",
  "admin.auth.subtitle": "Sign in or create an account to continue.",
  "admin.mode.signIn": "Sign in",
  "admin.mode.signUp": "Sign up",
  "admin.mode.forgotPassword": "Forgot password",
  "admin.mode.verifyEmail": "Verify email",
  "admin.link.forgotPassword": "Forgot password?",
  "admin.link.backToSignIn": "Back to sign in",
  "admin.auth.switch.noAccount": "Don't have an account?",
  "admin.auth.switch.haveAccount": "Already have an account?",
  "admin.field.email": "Email",
  "admin.field.password": "Password",
  "admin.field.name": "Name",
  "admin.field.acceptTerms": "I accept the terms and conditions",
  "admin.terms.prefix": "I accept the",
  "admin.terms.linkLabel": "Terms of Use",
  "admin.terms.modalTitle": "Terms of Use",
  "admin.terms.popupTitle": "Terms of Use updated",
  "admin.terms.popupPrefix": "We've updated our",
  "admin.terms.popupSuffix": "To continue, review and accept the latest version.",
  "admin.terms.bannerMessage": "We're updating our terms of use, which will be in effect from {effectiveDate}.",
  "admin.terms.bannerCta": "Click here to review and accept.",
  "admin.field.receiveProductUpdates": "I'd like to receive updates about the product's upcoming features.",
  "admin.field.resetToken": "Reset token (from email)",
  "admin.field.newPassword": "New password",
  "admin.field.verificationToken": "Verification token (from email)",
  "admin.password.requirements": "Use at least 15 characters with uppercase, lowercase, number, and special character.",
  "admin.password.rule.length": "At least 15 characters",
  "admin.password.rule.uppercase": "At least one uppercase letter (A-Z)",
  "admin.password.rule.lowercase": "At least one lowercase letter (a-z)",
  "admin.password.rule.number": "At least one number (0-9)",
  "admin.password.rule.special": "At least one special character",
  "admin.button.signingIn": "Signing in...",
  "admin.button.signIn": "Sign in",
  "admin.auth.button.creatingAccount": "Creating account...",
  "admin.auth.button.createAccount": "Create account",
  "admin.button.acceptTerms": "Accept Terms of Use",
  "admin.button.acceptingTerms": "Accepting...",
  "admin.button.close": "Close",
  "admin.button.requesting": "Requesting...",
  "admin.button.requestReset": "Request reset",
  "admin.button.updating": "Updating...",
  "admin.button.setNewPassword": "Set new password",
  "admin.button.verifying": "Verifying...",
  "admin.button.verifyEmail": "Verify email",
  "admin.button.sending": "Sending...",
  "admin.button.resendVerification": "Resend verification email",
  "admin.auth.error.organizationDisabled": "This user organization is disabled.",
  "admin.auth.error.emailVerificationRequired": "Please verify your email before signing in.",
  "admin.auth.error.forgotPasswordRequestFailed": "Password reset request failed.",
  "admin.auth.error.invalidCredentials": "Invalid email or password.",
  "admin.auth.error.passwordResetInvalid": "Invalid or expired token, or invalid password.",
  "admin.auth.error.robotDetectionFailed": "Human verification failed. Please try again.",
  "admin.auth.error.resendVerificationFailed": "Could not resend verification email.",
  "admin.auth.error.signUpFailed": "Sign-up failed.",
  "admin.auth.error.termsAcceptanceFailed": "Could not accept the latest Terms of Use.",
  "admin.auth.error.twoFactorInvalid": "Invalid or expired authentication code.",
  "admin.auth.error.userAlreadyExists": "This user already exists. Use forgot password.",
  "admin.auth.error.verifyEmailInvalid": "Invalid or expired verification token.",
  "admin.message.verifyBeforeSignIn": "Please verify your email before signing in.",
  "admin.message.signInFailed": "Sign-in failed.",
  "admin.message.userExists": "This user already exists. Use forgot password.",
  "admin.auth.message.checkEmail": "Check your email to verify your account.",
  "admin.message.signUpFailed": "Sign-up failed.",
  "admin.message.termsUnavailable": "The latest Terms of Use is unavailable right now.",
  "admin.message.termsAcceptanceFailed": "Could not accept the latest Terms of Use.",
  "admin.message.forgotPasswordRequested": "If a matching user exists, a password reset email has been sent.",
  "admin.message.forgotPasswordRequestFailed": "Password reset request failed.",
  "admin.message.passwordResetSuccess": "Password has been updated.",
  "admin.message.passwordResetFailed": "Invalid or expired token, or invalid password.",
  "admin.message.verifyEmailSuccess": "Email verified. You can now sign in.",
  "admin.message.verifyEmailFailed": "Invalid or expired verification token.",
  "admin.auth.message.resendVerificationSuccess": "If the account is unverified, a new verification email has been sent.",
  "admin.message.resendVerificationFailed": "Could not resend verification email.",
  "admin.navlist.navigator": "Navigator",
  "admin.navlist.title.organizations": "Organizations",
  "admin.navlist.title.sites": "Sites",
  "admin.navlist.title.signs": "Signs",
  "admin.navlist.title.translations": "Translations",
  "admin.navlist.parentFolderLabel": "..",
  "admin.navlist.parentFolder": "Parent folder",
  "admin.navlist.parentFolder.organizations": "Back to organizations",
  "admin.navlist.parentFolder.sites": "Back to sites",
  "admin.navlist.parentFolder.signs": "Back to signs",
  "admin.navlist.loading": "Loading...",
  "admin.navlist.empty": "No items yet.",
  "admin.navlist.scrollForMore": "Scroll for more...",
  "admin.navlist.error.loadFailed": "Unable to load list.",
  "admin.navlist.error.selectOrganization": "Select an organization to view sites.",
  "admin.navlist.error.selectSite": "Select a site to view signs.",
  "admin.navlist.error.selectSign": "Select a sign to view translations.",
  "admin.navlist.openMobilePanel": "Open navigation",
  "admin.navlist.closeMobilePanel": "Close navigation",
  "admin.navlist.openChildren": "Open children",
  "admin.navlist.includeArchived": "Include archived items",
  "admin.navlist.sort.label": "Sort by",
  "admin.navlist.sort.createdAtAsc": "Creation date, oldest first",
  "admin.navlist.sort.createdAtDesc": "Creation date, newest first",
  "admin.navlist.sort.languageAsc": "Language code, A-Z",
  "admin.navlist.sort.languageDesc": "Language code, Z-A",
  "admin.navlist.sort.nameAsc": "Name, A-Z",
  "admin.navlist.sort.nameDesc": "Name, Z-A",
  "admin.navlist.searchPlaceholder": "Search names and descriptions",
  "admin.navlist.searchLanguagesPlaceholder": "Filter languages",
  "admin.navlist.searchAction": "Search",
  "admin.navlist.emptySearch": "No matching items.",
  "admin.navlist.expandPanel": "Expand panel",
  "admin.navlist.collapsePanel": "Collapse panel",
  "admin.navlist.resizePanel": "Resize left panel",
  "admin.detail.eyebrow": "Details",
  "admin.detail.title.empty": "Details",
  "admin.detail.title.organization": "Organization",
  "admin.detail.title.site": "Site",
  "admin.detail.title.sign": "Sign",
  "admin.detail.title.translation": "Translation",
  "admin.detail.empty": "Select an item to view details.",
  "admin.detail.loading": "Loading details...",
  "admin.detail.error.loadFailed": "Unable to load details.",
  "admin.detail.error.saveFailed": "Unable to save changes.",
  "admin.detail.error.archiveFailed": "Unable to archive item.",
  "admin.detail.error.unarchiveFailed": "Unable to unarchive item.",
  "admin.detail.helper": "Select an item on the left or click the button to create a new one.",
  "admin.detail.confirm.discard": "Discard your changes?",
  "admin.detail.confirm.discardTitle": "Discard changes",
  "admin.detail.confirm.archive": "Archive this item?",
  "admin.detail.confirm.archiveTitle": "Archive item",
  "admin.detail.confirm.unarchive": "Unarchive this item?",
  "admin.detail.confirm.unarchiveTitle": "Unarchive item",
  "admin.popup.cancel": "Cancel",
  "admin.popup.close": "Close",
  "admin.popup.confirm": "Confirm",
  "admin.organizationInvitation.accept": "Accept invitation",
  "admin.organizationInvitation.confirm.accept": "Accept this organization invitation?",
  "admin.organizationInvitation.confirm.decline": "Decline this organization invitation?",
  "admin.organizationInvitation.decline": "Decline invitation",
  "admin.organizationInvitation.result.accepted": "Invitation accepted.",
  "admin.organizationInvitation.result.alreadyAccepted": "This invitation was already accepted.",
  "admin.organizationInvitation.result.alreadyDeclined": "This invitation was already declined.",
  "admin.organizationInvitation.result.belongsToAnotherUser": "This invitation belongs to another user. Sign in as the invited user to respond.",
  "admin.organizationInvitation.result.cancelled": "This invitation was cancelled.",
  "admin.organizationInvitation.result.declined": "Invitation declined.",
  "admin.organizationInvitation.result.expired": "This invitation has expired.",
  "admin.organizationInvitation.result.expiredOrResolved": "This invitation has expired or was already accepted or declined.",
  "admin.organizationInvitation.result.invalid": "This invitation is invalid.",
  "admin.organizationInvitation.title": "Organization invitation",
  "admin.organizationInvitation.title.accept": "Accept invitation",
  "admin.organizationInvitation.title.decline": "Decline invitation",
  "admin.detail.action.create": "Create",
  "admin.detail.action.edit": "Edit",
  "admin.detail.action.save": "Save",
  "admin.detail.action.discard": "Discard",
  "admin.detail.action.archive": "Archive",
  "admin.detail.action.unarchive": "Unarchive",
  "admin.detail.action.delete": "Delete",
  "admin.detail.action.hideNavigator": "Hide navigator",
  "admin.detail.action.showNavigator": "Show navigator",
  "admin.detail.action.createOrganization": "Create organization",
  "admin.detail.action.createSite": "Create site",
  "admin.detail.action.createSign": "Create sign",
  "admin.detail.action.createTranslation": "Create translation",
  "admin.permission.disabledTooltipSuffix": "(not permitted)",
  "admin.dataProblem.disabledTooltipSuffix": "(data problem)",
  "admin.subscription.limitReachedTooltipSuffix": "(subscription limit reached)",
  "admin.subscription.currentAmount": "current",
  "admin.subscription.limitAmount": "limit",
  "admin.subscription.expiredBanner": "All permissions have been revoked because of subscription expiration, and all data is now read-only.",
  "admin.detail.field.id": "ID",
  "admin.detail.field.organizationId": "Organization ID",
  "admin.detail.field.siteId": "Site ID",
  "admin.detail.field.signId": "Sign ID",
  "admin.detail.field.uuid": "UUID",
  "admin.detail.field.name": "Name",
  "admin.detail.field.email": "Email",
  "admin.detail.field.emailLanguage": "Email language",
  "admin.detail.field.role": "Role",
  "admin.detail.field.description": "Description",
  "admin.detail.field.language": "Language",
  "admin.detail.field.content": "Content",
  "admin.detail.field.viewUrl": "View URL",
  "admin.detail.field.qrCode": "QR code",
  "admin.detail.field.archivedAt": "Archived at",
  "admin.detail.field.expiresAt": "Expires at",
  "admin.detail.field.maxActiveSites": "Max active sites",
  "admin.detail.field.maxActiveSigns": "Max active signs",
  "admin.detail.field.maxActiveTranslations": "Max active translations",
  "admin.detail.field.maxTranslationLength": "Max translation length",
  "admin.detail.field.maxActiveUsers": "Max active users",
  "admin.copy.copy": "Copy",
  "admin.copy.copied": "Copied",
  "admin.export.svg": "Export SVG",
  "admin.export.saved": "Saved",
  "admin.detail.visibility.public": "This information will be displayed/accessible for public users when they view signs.",
  "admin.detail.visibility.internal": "This is internal technical information for yourself, not visible to the public.",
  "admin.detail.language.DE": "German",
  "admin.detail.language.EN": "English",
  "admin.detail.language.ES": "Spanish",
  "admin.detail.language.FR": "French",
  "admin.detail.language.HU": "Hungarian",
  "admin.markdownEditor.sourceLabel": "Markdown source",
  "admin.route.placeholder.eyebrow": "Not implemented",
  "admin.route.profile.title": "Profile",
  "admin.route.profile.description": "Profile settings are not implemented yet.",
  "admin.route.administration.title": "Administration",
  "admin.route.administration.description": "Administration tools are not available.",
  "admin.administration.title": "Administration",
  "admin.administration.tabs.title": "Administration sections",
  "admin.administration.tab.disableUser": "Disable user",
  "admin.administration.tab.systemInformation": "System information",
  "admin.administration.disableUser.submit": "Disable user",
  "admin.administration.disableUser.submitting": "Disabling...",
  "admin.administration.disableUser.success": "User disabled.",
  "admin.administration.disableUser.error": "Could not disable the user.",
  "admin.administration.systemInformation.applicationVersion": "Application version",
  "admin.administration.systemInformation.environment": "Environment",
  "admin.administration.systemInformation.gitBranch": "Git branch",
  "admin.administration.systemInformation.gitCommitId": "Git commit",
  "admin.administration.systemInformation.error": "Could not load system information.",
  "admin.profile.title": "Your profile",
  "admin.profile.tabs.title": "Profile sections",
  "admin.profile.tab.basic": "Basic data",
  "admin.profile.tab.security": "Security",
  "admin.profile.tab.terms": "Accepted terms",
  "admin.profile.role.superAdmin": "Super admin",
  "admin.profile.role.user": "User",
  "admin.profile.terms.empty": "No accepted Terms of Use found yet.",
  "admin.profile.terms.acceptedAt": "Accepted at",
  "admin.profile.terms.effectiveFrom": "Effective from",
  "admin.profile.terms.actions": "Actions",
  "admin.profile.terms.open": "Open terms",
  "admin.organization.tabs.title": "Organization sections",
  "admin.organization.tab.details": "Details",
  "admin.organization.tab.domains": "Domains",
  "admin.organization.tab.internals": "Internals",
  "admin.organization.tab.users": "Users",
  "admin.organization.tab.subscription": "Subscription",
  "admin.organization.internals.crmId": "CRM ID",
  "admin.organization.domains.empty": "Domain settings are not available.",
  "admin.organization.domains.enable": "Enable",
  "admin.organization.domains.disable": "Disable",
  "admin.organization.domains.enabled": "Enabled",
  "admin.organization.domains.disabled": "Disabled",
  "admin.organization.domains.status": "Status",
  "admin.organization.domains.status.active": "Active",
  "admin.organization.domains.status.archived": "Archived",
  "admin.organization.domains.createdAt": "Created",
  "admin.organization.domains.section.trial": "Trial domain",
  "admin.organization.domains.section.managed": "Managed domains",
  "admin.organization.domains.section.connected": "Connected domains",
  "admin.organization.domains.type.CONNECTED": "Connected",
  "admin.organization.domains.type.EDGE": "Edge",
  "admin.organization.domains.type.MANAGED": "Managed",
  "admin.organization.domains.type.TRIAL": "Trial",
  "admin.organization.domains.trial.enabled": "Allow access through the shared trial hostname",
  "admin.organization.domains.trial.hostname": "Trial hostname",
  "admin.organization.domains.trial.enableTitle": "Enable trial domain",
  "admin.organization.domains.trial.enableConfirm": "Enable access through the shared trial hostname?",
  "admin.organization.domains.trial.disableTitle": "Disable trial domain",
  "admin.organization.domains.trial.disableConfirm": "Disable access through the shared trial hostname?",
  "admin.organization.domains.managed.add": "Add managed domain",
  "admin.organization.domains.managed.empty": "No managed domains found.",
  "admin.organization.domains.managed.hostname": "Hostname",
  "admin.organization.domains.managed.label": "Label",
  "admin.organization.domains.managed.archiveTitle": "Archive managed domain",
  "admin.organization.domains.managed.archiveConfirm": "Archive this managed domain?",
  "admin.organization.domains.managed.unarchiveTitle": "Unarchive managed domain",
  "admin.organization.domains.managed.unarchiveConfirm": "Unarchive this managed domain?",
  "admin.organization.domains.managed.deleteTitle": "Delete managed domain",
  "admin.organization.domains.managed.deleteConfirm": "Delete this archived managed domain?",
  "admin.organization.domains.managed.availability.checking": "Checking availability...",
  "admin.organization.domains.managed.availability.available": "This managed domain is available.",
  "admin.organization.domains.managed.availability.unavailable": "This managed domain is not available.",
  "admin.organization.domains.connected.add": "Add connected domain",
  "admin.organization.domains.connected.empty": "No connected domains found.",
  "admin.organization.domains.connected.hostname": "Hostname",
  "admin.organization.domains.connected.target": "Managed target",
  "admin.organization.domains.connected.targetMissing": "Managed domain missing",
  "admin.organization.domains.connected.verified": "Verified",
  "admin.organization.domains.connected.notVerified": "Not verified",
  "admin.organization.domains.connected.notVerifiedYet": "Not verified yet",
  "admin.organization.domains.connected.verify": "Verify",
  "admin.organization.domains.connected.archiveTitle": "Archive connected domain",
  "admin.organization.domains.connected.archiveConfirm": "Archive this connected domain?",
  "admin.organization.domains.connected.unarchiveTitle": "Unarchive connected domain",
  "admin.organization.domains.connected.unarchiveConfirm": "Unarchive this connected domain? It will become unverified.",
  "admin.organization.domains.connected.deleteTitle": "Delete connected domain",
  "admin.organization.domains.connected.deleteConfirm": "Delete this archived connected domain?",
  "admin.organization.domains.connected.verifyTitle": "Verify connected domain",
  "admin.organization.domains.connected.verifySucceeded": "Verification succeeded.",
  "admin.organization.domains.connected.actualTarget": "Detected target",
  "admin.organization.domains.connected.overrideLabel": "Verification override",
  "admin.organization.domains.connected.overrideVerified": "Mark this connected domain as verified even if the DNS check fails.",
  "admin.organization.domains.connected.saveVerified": "Save as verified",
  "admin.organization.domains.connected.recordType": "Record type",
  "admin.organization.domains.connected.recordTarget": "Record target",
  "admin.organization.domains.connected.setupHint": "Create this CNAME record in the customer's DNS before verification.",
  "admin.organization.domains.error.organizationNotFound": "The organization could not be found.",
  "admin.organization.domains.error.settingsNotFound": "The domain settings could not be found.",
  "admin.organization.domains.error.managedLabelInvalid": "The managed domain label is invalid.",
  "admin.organization.domains.error.managedLabelReserved": "This managed domain label is reserved.",
  "admin.organization.domains.error.managedLabelUnavailable": "This managed domain label is unavailable.",
  "admin.organization.domains.error.managedHostnameUnavailable": "This managed domain hostname already exists in DNS.",
  "admin.organization.domains.error.managedDomainNotFound": "The managed domain could not be found.",
  "admin.organization.domains.error.managedDomainArchived": "The managed domain is archived.",
  "admin.organization.domains.error.managedDomainInUse": "The managed domain is still used by a connected domain.",
  "admin.organization.domains.error.dnsConfigurationInvalid": "DNS configuration is incomplete.",
  "admin.organization.domains.error.dnsOperationFailed": "The DNS operation failed.",
  "admin.organization.domains.error.connectedHostnameInvalid": "The connected domain hostname is invalid.",
  "admin.organization.domains.error.connectedHostnameUnavailable": "This connected domain hostname is already used by this organization.",
  "admin.organization.domains.error.connectedApexNotAllowed": "Apex domains are not allowed here.",
  "admin.organization.domains.error.connectedDomainNotFound": "The connected domain could not be found.",
  "admin.organization.domains.error.connectedDomainArchived": "The connected domain is archived.",
  "admin.organization.domains.error.connectedCnameNotFound": "No CNAME record was found for the connected domain.",
  "admin.organization.domains.error.connectedTargetMismatch": "The connected domain points to the wrong managed target.",
  "admin.sign.viewDomain.selected": "QR domain",
  "admin.sign.viewDomain.warning.managed": "A connected domain is available. Generate QR codes with a connected domain instead of a managed domain.",
  "admin.sign.viewDomain.warning.trial": "A higher-priority domain is available. Generate QR codes with a connected or managed domain instead of the trial domain.",
  "admin.organization.subscription.empty": "Subscription details are not available.",
  "admin.organization.subscription.group.organization": "Organization",
  "admin.organization.subscription.group.sites": "Sites",
  "admin.organization.subscription.group.signs": "Signs",
  "admin.organization.subscription.group.translations": "Translations",
  "admin.organization.subscription.preset.twoWeeks": "Now + 2 weeks",
  "admin.organization.subscription.preset.oneMonth": "Now + 1 month",
  "admin.organization.subscription.preset.oneYear": "Now + 1 year",
  "admin.site.tabs.title": "Site sections",
  "admin.site.tab.details": "Details",
  "admin.sign.tabs.title": "Sign sections",
  "admin.sign.tab.details": "Details",
  "admin.sign.tab.urls": "URLs",
  "admin.sign.urls.empty": "No URLs are available for this sign yet.",
  "admin.translation.tabs.title": "Translation sections",
  "admin.translation.tab.details": "Details",
  "admin.organizationUsers.add": "Add user",
  "admin.organizationUsers.cancelInvitation": "Cancel invitation",
  "admin.organizationUsers.cancelInvitationConfirm": "Cancel the invitation for",
  "admin.organizationUsers.changeRole": "Change role",
  "admin.organizationUsers.currentUser": "Current user",
  "admin.translation.lengthExceededBanner": "You've hit the maximum translation length that the organization's subscription allows.",
  "admin.organizationUsers.empty": "No users or pending invitations found.",
  "admin.organizationUsers.emptyName": "No name",
  "admin.organizationUsers.error.cancelInvitationFailed": "Could not cancel the invitation.",
  "admin.organizationUsers.error.inviteFailed": "Could not invite the user.",
  "admin.organizationUsers.error.loadFailed": "Could not load organization users.",
  "admin.organizationUsers.error.removeFailed": "Could not remove the user.",
  "admin.organizationUsers.error.resendInvitationFailed": "Could not resend the invitation.",
  "admin.organizationUsers.error.roleFailed": "Could not change the role.",
  "admin.organizationUsers.invite": "Invite",
  "admin.organizationUsers.invitedUntil": "Invitation expires",
  "admin.organizationUsers.notApplicable": "N/A",
  "admin.organizationUsers.remove": "Remove user",
  "admin.organizationUsers.removeConfirm": "Remove this user from the organization:",
  "admin.organizationUsers.resendInvitation": "Resend invitation email",
  "admin.organizationUsers.resendInvitationConfirm": "Resend the invitation email? The previous invitation link will stop working for",
  "admin.organizationUsers.role.ADMINISTRATOR": "Administrator",
  "admin.organizationUsers.role.EDITOR": "Editor",
  "admin.organizationUsers.role.OWNER": "Owner",
  "admin.organizationUsers.role.VIEWER": "Viewer",
  "admin.organizationUsers.status": "Status",
  "admin.organizationUsers.status.active": "Active",
  "admin.organizationUsers.status.invited": "Invited",
  "admin.twoFactor.account": "Account",
  "admin.twoFactor.authenticatorPrompt": "Enter the code from your authenticator app.",
  "admin.twoFactor.code": "Authentication code",
  "admin.twoFactor.codeName": "Code name",
  "admin.twoFactor.confirmAuthenticator": "Confirm authenticator",
  "admin.twoFactor.confirmCode": "Code from authenticator",
  "admin.twoFactor.disableConfirmBody.account": "Disable two-factor authentication for your account?",
  "admin.twoFactor.disableConfirmTitle": "Disable two-factor authentication",
  "admin.twoFactor.digits": "Digits",
  "admin.twoFactor.disable": "Disable 2FA",
  "admin.twoFactor.emailPrompt": "We sent a sign-in code to your email address.",
  "admin.twoFactor.enableEmail": "Use email codes",
  "admin.twoFactor.error.disableFailed": "Could not disable two-factor authentication.",
  "admin.twoFactor.error.enableFailed": "Could not enable two-factor authentication.",
  "admin.twoFactor.error.invalidCode": "Authenticator code is invalid.",
  "admin.twoFactor.error.setupFailed": "Could not start authenticator setup.",
  "admin.twoFactor.issuer": "Issuer",
  "admin.twoFactor.period": "Period seconds",
  "admin.twoFactor.recommendationBody.account": "Protect your account with an authenticator app or email sign-in code. You can configure it now from your profile security settings.",
  "admin.twoFactor.recommendationCta": "Open security settings",
  "admin.twoFactor.recommendationTitle": "Add two-factor authentication",
  "admin.twoFactor.secret": "Secret",
  "admin.twoFactor.sectionTitle": "Two-factor authentication",
  "admin.twoFactor.setupAuthenticator": "Set up authenticator app",
  "admin.twoFactor.setupInstructions": "Download a TOTP authenticator app such as Google Authenticator, Microsoft Authenticator, or similar, then scan this QR code or enter the manual details below.",
  "admin.twoFactor.status.disabled": "Two-factor authentication is not enabled.",
  "admin.twoFactor.status.email": "Two-factor authentication is enabled with email codes.",
  "admin.twoFactor.status.totp": "Two-factor authentication is enabled with an authenticator app.",
  "admin.twoFactor.switchToEmailConfirmBody": "Switch two-factor authentication from your authenticator app to email codes?",
  "admin.twoFactor.switchToEmailConfirmTitle": "Switch to email codes",
  "admin.twoFactor.timeBased": "Time based",
  "admin.twoFactor.type": "Type",
  "admin.twoFactor.verify": "Verify code",
  "admin.twoFactor.yourKey": "Your key",
  "admin.sessions.description": "Invalidate active sessions in other browsers and devices. Your current session stays active.",
  "admin.sessions.current": "Current session",
  "admin.sessions.empty": "No active sessions found.",
  "admin.sessions.expiresAt": "Expires at",
  "admin.sessions.invalidateFailed": "Could not invalidate other sessions.",
  "admin.sessions.invalidate": "Invalidate",
  "admin.sessions.invalidateOthers": "Invalidate other sessions",
  "admin.sessions.invalidateSuccess": "Other sessions were invalidated.",
  "admin.sessions.ipAddress": "IP address",
  "admin.sessions.lastAccessedAt": "Last active",
  "admin.sessions.loginAt": "Login time",
  "admin.sessions.sectionTitle": "Active sessions",
  "admin.sessions.userAgent": "Device / user agent",
  "admin.route.preferences.title": "Preferences",
  "admin.route.preferences.description": "Preferences will be available once personalization is delivered.",
  "admin.route.notFound.title": "Not Found",
  "admin.route.notFound.description": "The requested view is not available in the admin console.",
  "view.defaultTitle": "Rendered Markdown",
  "view.selectLanguage": "Select language",
  "view.speech.play": "Play audio",
  "view.speech.pause": "Pause audio",
  "view.speech.resetHint": "Hold for 2 seconds to reset to the beginning.",
  "view.loading": "Loading...",
  "view.loadFailed": "Could not load translation.",
  "view.unavailable": "The requested page isn't available.",
  "view.termsOfUseLoadFailed": "Could not load Terms of Use.",
  "view.noContent": "No content supplied.",
  "view.termsOfUse.notLatest": "This is not the latest Terms of Use.",
  "view.termsOfUse.openLatest": "Open the latest version",
  "view.chooseLanguage": "Choose language",
  "view.closeLanguageSelector": "Close language selector",
  "view.closeReportAbuseDialog": "Close report abuse dialog",
  "view.filterLanguagesPlaceholder": "Filter languages...",
  "view.filterLanguagesAria": "Filter languages by English or native name",
  "view.reportAbuse.thankYou": "Thank you for reporting improper use or behavior.",
  "view.reportAbuse.instructions": "Please provide as many details as possible, including the link to the translation.",
  "view.reportAbuse.opensEmailClient": "Clicking the button below will open your email client. It may prefill the email subject and add some body content. Please leave those there and add your feedback after it.",
  "request.error.accessDenied": "You do not have permission to perform this action.",
  "request.error.activeSubscriptionNotFound": "The active subscription could not be found.",
  "request.error.authenticationRequired": "Please sign in to continue.",
  "request.error.connectedDomainApexNotAllowed": "Apex domains are not allowed here.",
  "request.error.connectedDomainArchived": "The connected domain is archived.",
  "request.error.connectedDomainCnameNotFound": "The connected domain CNAME record could not be found.",
  "request.error.connectedDomainHostnameInvalid": "The connected domain hostname is invalid.",
  "request.error.connectedDomainHostnameUnavailable": "The connected domain hostname is unavailable.",
  "request.error.connectedDomainNotFound": "The connected domain could not be found.",
  "request.error.connectedDomainTargetMismatch": "The connected domain points to an unexpected target.",
  "request.error.correlationId": "Correlation ID",
  "request.error.dnsConfigurationInvalid": "The DNS configuration is invalid.",
  "request.error.dnsOperationFailed": "The DNS operation failed.",
  "request.error.emailVerificationRequired": "Email verification is required.",
  "request.error.generic": "Something went wrong. Please try again.",
  "request.error.invalidCredentials": "The credentials are invalid.",
  "request.error.invitationInvalid": "The invitation is invalid.",
  "request.error.invitationNotFound": "The invitation could not be found.",
  "request.error.managedDomainArchived": "The managed domain is archived.",
  "request.error.managedDomainHostnameUnavailable": "The managed domain hostname already exists in DNS.",
  "request.error.managedDomainInUse": "The managed domain is in use.",
  "request.error.managedDomainLabelInvalid": "The managed domain label is invalid.",
  "request.error.managedDomainLabelReserved": "The managed domain label is reserved.",
  "request.error.managedDomainLabelUnavailable": "The managed domain label is unavailable.",
  "request.error.managedDomainNotFound": "The managed domain could not be found.",
  "request.error.notFound": "The requested item could not be found.",
  "request.error.organizationDisabled": "The organization is disabled.",
  "request.error.organizationDomainSettingsNotFound": "The organization domain settings could not be found.",
  "request.error.organizationNotFound": "The organization could not be found.",
  "request.error.organizationUserMembershipNotFound": "The organization membership could not be found.",
  "request.error.passwordResetInvalid": "The password reset request is invalid.",
  "request.error.profileNotFound": "The profile could not be found.",
  "request.error.sessionNotFound": "The session could not be found.",
  "request.error.signNotFound": "The sign could not be found.",
  "request.error.siteNotFound": "The site could not be found.",
  "request.error.termsOfUseNotFound": "The Terms of Use could not be found.",
  "request.error.totpCodeInvalid": "The authenticator code is invalid.",
  "request.error.totpSetupRequired": "Authenticator setup must be started first.",
  "request.error.translationMaxLengthExceeded": "The translation exceeds the allowed maximum length.",
  "request.error.translationNotFound": "The translation could not be found.",
  "request.error.unexpected": "An unexpected error occurred.",
  "request.error.userAlreadyExists": "The user already exists.",
  "request.error.userNotFound": "The user could not be found.",
  "request.error.validation": "The request could not be processed.",
  "request.error.verifyEmailInvalid": "The email verification request is invalid.",
  "footer.about": "About",
  "footer.terms": "Terms and conditions",
  "footer.cookies": "Cookie settings",
  "footer.reportAbuse": "Report abuse",
  "theme.label.system": "Theme: system",
  "theme.label.light": "Theme: light",
  "theme.label.dark": "Theme: dark",
  "uiLanguage.switcherAria": "Switch interface language",
  "toolbar.toggleGroup": "toggle group",
  "toolbar.richText": "Rich text",
  "toolbar.source": "Source mode",
  "toolbar.blockTypes.paragraph": "Paragraph",
  "toolbar.blockTypes.quote": "Quote",
  "toolbar.blockTypes.heading": "Heading {{level}}",
  "toolbar.blockTypeSelect.selectBlockTypeTooltip": "Select block type",
  "toolbar.blockTypeSelect.placeholder": "Block type",
  "toolbar.bold": "Bold",
  "toolbar.removeBold": "Remove bold",
  "toolbar.italic": "Italic",
  "toolbar.removeItalic": "Remove italic",
  "toolbar.underline": "Underline",
  "toolbar.removeUnderline": "Remove underline",
  "toolbar.bulletedList": "Bulleted list",
  "toolbar.numberedList": "Numbered list",
  "toolbar.checkList": "Check list",
  "toolbar.link": "Create link",
  "toolbar.codeBlock": "Insert Code Block",
  "toolbar.undo": "Undo {{shortcut}}",
  "toolbar.redo": "Redo {{shortcut}}"
}
